{
  "steps": [
    "2.jpg",
    "4.jpg",
    "5.jpg",
    "6.jpg",
    "youtube:38RMZ9H7Cg8"
  ],
  "random": true
}